import { encodeParam } from "utilities/misc";
import { get, post } from "utilities/network";

export const httpFetchTransactions = (
  currencyType: string,
  transactionType: string,
  place?: string,
  crypto?: string,
  limit?: number,
  page?: number,
  status?: string,
) => {
  return get(
    `admin/transactions/fetch?currencyType=${encodeParam(currencyType)}&transactionType=${encodeParam(transactionType)}&crypto=${encodeParam(crypto)}&place=${encodeParam(place)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}&status=${encodeParam(status)}`,
  );
};

export const httpVendorDeposits = (type: string) => {
  return get(
    `admin/merchants/deposits?type=${encodeParam(type.replace("completed", "successful"))}`,
  );
};

export const httpVendorDeposit = (id: number) => {
  return get(`admin/merchants/deposit/${encodeParam(id)}`);
};

export const httpFetchPlanTransactions = (id: number, crypto?: string) => {
  return get(
    `admin/transactions/fetchPlanTransactions/${encodeParam(id)}?crypto=${encodeParam(crypto)}`,
  );
};

export const httpUSearchTransaction = (id: string, signal?: AbortSignal) => {
  return get(`admin/transactions/search?search=${encodeParam(id)}`, signal);
};

export const httpFetchVouchers = (
  filter: string,
  limit?: number,
  page?: number,
) => {
  return get(
    `admin/transactions/vouchers?filter=${encodeParam(filter)}&limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};

export const httpFetchAdminMarkets = (limit?: number, page?: number) => {
  return get(
    `admin/transactions/fetchAdminMarket?limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};

export const httpSwapStatus = async ({ id }: { id: string }) => {
  return await post("admin/transactions/getSwapStatus", {
    id,
  });
};

export const httpFetchOTCStats = () => {
  return get("admin/otc/stats");
};

export const httpFetchOTCTransactions = (
  page?: number,
  limit?: number,
  status?: string,
  currencyType?: string,
  crypto?: string,
  startDate?: string,
  endDate?: string,
  transactionType?: string,
) => {
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (limit) params.append("limit", String(limit));
  if (status) params.append("status", status);
  if (currencyType) params.append("currencyType", currencyType);
  if (crypto) params.append("crypto", crypto);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (transactionType) params.append("transactionType", transactionType);

  return get(`admin/otc/transactions?${params.toString()}`);
};

export const httpFetchFlaggedTransactions = (
  page?: number,
  limit?: number,
  moduleStatus: "open" | "resolved" | "all" = "open",
) => {
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (limit) params.append("limit", String(limit));
  params.append("moduleStatus", moduleStatus);

  return get(`admin/transactions/flagged-transactions?${params.toString()}`);
};

export const httpFetchRiskFlaggedTransactions = (
  limit: number = 50,
  page: number = 1,
) => {
  return get(
    `admin/transactions/riskReview?limit=${encodeParam(limit)}&page=${encodeParam(page)}`,
  );
};

export const httpReviewHeldOTCTransaction = (
  id: number,
  action: "release" | "reject",
  comment: string,
) =>
  post(`admin/otc/onboarding/held-transactions/${id}/${action}`, { comment });
